/*
 * The Provider Dashboard app route is structured
 * in the following way:
 * <DASHBOARD>/<PROVIDER>/<PROCESS_STEP>/<PROCESS_INFO>
 */
const config = {
  APP_URL:
    process.env.NODE_ENV !== 'development'
      ? process.env.REACT_APP_URL
      : `${window.location.protocol}//${window.location.hostname}:3000`,
  APP_PATH: process.env.REACT_APP_PATH,
  APP_SEGMENTS: {
    PROVIDER: 0,
    PROCESS_STEP: 1,
    PROCESS_INFO: 2
  }
};

export default config;
